import * as React from "react";
import Config from "../../Config";
import MetamodelStore from "../../resources/data/MetamodelStore";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import '../../styles/ColumnsCustomizer.css';
import '../../styles/Button.css';

export default class ColumnsCustomizer extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            aItems: null,
            sSelectedOrderBy: null,
            aItemsDefault: null
        };

        Config.getConfig();
    }

    componentDidMount = () =>
    {
        if (this.props.aItemsDefault)
        {
            this.setItemsDefault();
        }
        this.setItems()
    }

    /**
     * Add default columns to the list
     * Default columns are not returned outside this component
     */
    setItemsDefault = () =>
    {
        var aItemsDefault = null;
        for (var i = 0; i < this.props.aItemsDefault.length; i++)
        {
            try
            {
                const aNameAttrLabel = MetamodelStore.getInstance().getMetaPropertyByLangIndependent(this.props.aItemsDefault[i]);
                if (!aNameAttrLabel)
                {
                    continue;
                }
                const aNameLandDependent = Config.getLangName(aNameAttrLabel);
                if (!aItemsDefault)
                {
                    aItemsDefault = [];
                }
                aItemsDefault.push({
                    label: aNameLandDependent,
                    id: aNameAttrLabel.id,
                    name: aNameAttrLabel.sName,
                    defaultChecked: false,
                    isDefault: true
                })
            } catch (err)
            {
                console.warn(err);
            }
        };
        this.state.aItemsDefault = aItemsDefault;
        this.setState({});
    }

    /**
     * Set items to state and add desired elements
     * @param {Object} aInputItems 
     * @returns 
     */
    setItems = (aInputItems) =>
    {
        var aItemsModified = null;
        if (aInputItems)
        {
            aItemsModified = aInputItems.map(aItem =>
            {
                try
                {
                    if (!aItem.hasOwnProperty("extra") || !aItem.extra.isPair)
                    {
                        let sItemName = null;
                        if ((typeof aItem === 'object') && Object.hasOwnProperty.call(aItem, 'name'))
                        {
                            sItemName = aItem.name.split("#")[0];
                        } else if (typeof aItem === 'string')
                        {
                            sItemName = aItem;
                        } else
                        {
                            return null;
                        }

                        var aItemData = MetamodelStore.getInstance().getMetaPropertyByLangIndependent(sItemName);
                        if (!aItemData)
                        {
                            return null;
                        }
                        var aItemMod = (typeof aItem === 'object') ? aItem : { name: sItemName };
                        aItemMod['label'] = Config.getLangName(aItemData);
                        aItemMod['id'] = aItemData.id;
                        aItemMod['allowShift'] = true;
                        if (aItem.hasOwnProperty("extra"))
                        {
                            if (aItem.extra.hasOwnProperty("relation") && aItem.extra.relation)
                            {
                                aItemMod.name = aItemMod.name.concat("#", aItemMod.extra.relation);
                                if (aItem.extra.hasOwnProperty("isTarget") && aItem.extra.isTarget)
                                {
                                    aItemMod.name = aItemMod.name.concat(
                                        "#",
                                        (aItem.extra.hasOwnProperty("direction") && aItem.extra.direction === "INCOMING") ?
                                            "SOURCE" :
                                            "TARGET"
                                    );
                                }
                            }
                            if (aItem.extra.hasOwnProperty("relationLang") && aItem.extra.relationLang)
                            {
                                aItemMod.label = aItemMod.label.concat(" (", aItem.extra.relationLang);
                                if (aItem.extra.hasOwnProperty("isTarget") && aItem.extra.isTarget)
                                {
                                    aItemMod.label = aItemMod.label.concat(
                                        ", ",
                                        (aItem.extra.hasOwnProperty("direction") && aItem.extra.direction === "INCOMING") ?
                                            Config.strings.modals.modelObj.nestedSource :
                                            Config.strings.modals.modelObj.nestedTarget,
                                        ")");
                                } else
                                {
                                    aItemMod.label = aItemMod.label.concat(")");
                                }
                            }
                        }
                        return aItemMod;
                    } else
                    {
                        if (!aItem.hasOwnProperty("extra"))
                        {
                            return null;
                        }
                        var aItemMod = {
                            name: aItem.name,
                            label: aItem.extra.relationLang,
                            relation: aItem.extra.relation,
                            allowShift: true,
                            isPair: aItem.extra.isPair
                        };
                        let aLabelParts = [];
                        aItem.extra.attrs.sort((aA, aB) =>
                        {
                            if (aA.extra.isTarget)
                            {
                                return 1;
                            } else if (aB.extra.isTarget)
                            {
                                return -1;
                            }
                            return 0;
                        });
                        if (aItem.extra.attrs[0].extra.hasOwnProperty("direction"))
                        {
                            aItem.name = aItem.name.concat(
                                "#",
                                (aItem.extra.attrs[0].extra.direction === "INCOMING") ?
                                    "SOURCE" :
                                    "TARGET"
                            );
                        }
                        aItemMod["attrs"] = aItem.extra.attrs.map(aItemAttr =>
                        {
                            let aItemData = MetamodelStore.getInstance().getMetaPropertyByLangIndependent(aItemAttr.name);
                            if (!aItemData)
                            {
                                return null;
                            }
                            var aItemModPart = (typeof aItemAttr === 'object') ? aItemAttr : { name: aItemAttr.name };
                            aItemModPart["id"] = aItemData.id;
                            let sLabelPart = Config.getLangName(aItemData);
                            if (aItemAttr.extra.hasOwnProperty("isTarget") && aItemAttr.extra.isTarget)
                            {
                                sLabelPart = sLabelPart.concat(
                                    "-",
                                    (aItemAttr.extra.hasOwnProperty("direction") && aItemAttr.extra.direction === "INCOMING") ?
                                        Config.strings.modals.modelObj.nestedSource :
                                        Config.strings.modals.modelObj.nestedTarget
                                );
                            }
                            aLabelParts.push(sLabelPart);

                            return aItemModPart;
                        });
                        aItemMod.label = aItemMod.label.concat("(", aLabelParts.join(", "), ")");
                        return aItemMod;
                    }
                } catch (err)
                {
                    console.warn(err);
                    return null;
                }
            }).filter(aItem =>
            {
                // aItem && (!this.state.aItemsDefault || (this.state.aItemsDefault && !this.state.aItemsDefault.find(aItemInner => aItemInner.id === aItem.id)))
                return aItem // can display default property when selected manually
            });
        }

        // merge default and selected columns 
        if (this.state.aItemsDefault)
        {
            aItemsModified = this.state.aItemsDefault.concat(aItemsModified ? aItemsModified : []);
        }

        this.setState({
            aItems: aItemsModified
        });
        return aItemsModified;
    }

    /**
     * Get column used to set table order
     * @returns 
     */
    getOrderBySelection = () =>
    {
        return this.state.sSelectedOrderBy;
    }

    getColumnsOrder = () =>
    {
        if (!this.state.aItems)
        {
            return [];
        }

        var aColumnsOrder = this.state.aItems.map(aItem =>
        {
            if (Object.hasOwnProperty.call(aItem, 'isDefault') && aItem.isDefault)
            {
                return null;
            }
            return aItem.name;
        });
        return aColumnsOrder;
    }

    /**
     * Set column used to setup table order
     * @param {Object} aEvent 
     */
    setOrderBySelection = (aEvent) =>
    {
        const nSelectedIndex = aEvent.target.value;
        this.setState({
            sSelectedOrderBy: Object.hasOwnProperty.call(this.state.aItems[nSelectedIndex], 'name') ? this.state.aItems[nSelectedIndex].name : null
        });
    }

    /**
     * Shift items in array
     * @param {Number} nIndex 
     * @param {Number} nDir 
     */
    changeColumnOrder = (nIndex, nDir) =>
    {
        const nTargetIndex = nIndex + nDir;
        if (0 <= nIndex && 0 <= nTargetIndex && (!this.state.aItemsDefault || (this.state.aItemsDefault && nTargetIndex > this.state.aItemsDefault.length - 1)))
        {
            this.state.aItems.splice(nTargetIndex, 0, this.state.aItems.splice(nIndex, 1)[0]);
        }
        this.setState({});
    }

    render()
    {
        const aItems = this.state.aItems;
        const { bSortEnable, bShiftEnable } = this.props;

        if (!aItems || !aItems.length || 0 >= aItems.length)
        {
            return null;
        }

        return (
            <div>
                {aItems.map((aItem, nIndex) =>
                {
                    return (
                        <div
                            key={nIndex}
                            className="ColumnsCustomizer__item"
                            onChange={aEvent => this.setOrderBySelection(aEvent)}
                        >
                            <div className="ColumnsCustomizer__item_orderButtons">
                                {(bShiftEnable && Object.hasOwnProperty.call(aItem, 'allowShift') && aItem.allowShift)
                                    && <div>
                                        <button
                                            className="wrcButtonOrder"
                                            value={nIndex}
                                            onClick={(aEvent) =>
                                            {
                                                var sValue = aEvent.currentTarget.value;
                                                this.changeColumnOrder(parseInt(sValue), 1)
                                            }}
                                        >
                                            <KeyboardArrowDownIcon />
                                        </button>
                                        <button
                                            className="wrcButtonOrder"
                                            value={nIndex}
                                            onClick={(aEvent) =>
                                            {
                                                var sValue = aEvent.currentTarget.value;
                                                this.changeColumnOrder(parseInt(sValue), -1)
                                            }}
                                        >
                                            <KeyboardArrowUpIcon />
                                        </button>
                                    </div>
                                }
                            </div>

                            {(
                                bSortEnable &&
                                ((
                                    (!aItem.hasOwnProperty('extra') || (!aItem.extra.hasOwnProperty('sType') && !aItem.extra.hasOwnProperty("relation"))) ||
                                    (aItem && aItem.hasOwnProperty('extra') && !aItem.extra.hasOwnProperty("relation") && (aItem.extra.hasOwnProperty('sType') && aItem.extra.sType != 'REL'))
                                ) && !aItem.isPair)
                            )
                                && <input
                                    type="radio"
                                    id={aItem.id}
                                    value={nIndex}
                                    name="sortBy"
                                    defaultChecked={aItem.defaultChecked ? aItem.defaultChecked : false}
                                    checked={this.state.sSelectedOrderBy === aItem.name}
                                />}
                            {' '}
                            <label>{aItem.label}</label>
                        </div>
                    )
                })}
            </div>
        );
    }
}